import React from 'react';
import Slide from '@material-ui/core/Slide';

export const SlideUpTransition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});
SlideUpTransition.displayName = 'slide_up_transition';
